import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${BREAKPOINT.MD}) {
    width: 58%;
  }

  @media (max-width: ${BREAKPOINT.LG}) {
    width: 40%;
    margin-bottom: 30px;
  }

  ${bp('sm')`
    width: 100%;
    text-align: center;
  `}

  form {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${bp('sm')`
      flex-direction: column;
    `}

    > div {
      width: 67%;
      padding: 0;

      @media (max-width: ${BREAKPOINT.LG}) {
        width: 74%;
      }

      ${bp('sm')`
        width: 100%;
      `}

      input {
        height: 45px;
      }
    }

    button {
      min-width: 122px;
      margin-left: 16px;
      ${bp('sm')`
        margin-top: 20px;
      `}

      > div {
        padding: 11px 30px;
      }
    }
  }
`
